<template>
    <div :id="'sector_'+record.sector" class="clearfix rightLine  " :style="'display:'+graduallyView+';'">
        <div class="topMargin"></div>
        <span   v-if="typeof record.line1!=='undefined' ">
            <span   v-if="record.line1.trim().length>0">
                <span   v-if="$t(record.line1).trim().length>0">
                    <div  class="clearfix text-left" style="margin:5px 0 0 0; padding:0 0 0 0px; border:solid 0px red;"><b>{{$t(record.line1)}}</b></div>
                </span>
            </span>
        </span>        
        <span   v-if="typeof record.line2!=='undefined' ">
            <span   v-if="record.line2.trim().length>0">
                <span   v-if="$t(record.line2).trim().length>0">
                    <div  class="clearfix text-left" style="margin:5px 0 0 0; padding:0 0 0 20px; border:solid 0px red;"><li>{{$t(record.line2)}}</li></div>
                </span>
            </span>
        </span>        
        <span   v-if="typeof record.line3!=='undefined' ">
            <span   v-if="record.line3.trim().length>0">
                <span   v-if="$t(record.line3).trim().length>0">
                    <div  class="clearfix text-left" style="margin:5px 0 0 0; padding:0 0 0 20px; border:solid 0px red;"><li>{{$t(record.line3)}}</li></div>
                </span>
            </span>
        </span>        
        <span   v-if="typeof record.line4!=='undefined' ">
            <span   v-if="record.line4.trim().length>0">
                <span   v-if="$t(record.line4).trim().length>0">
                    <div  class="clearfix text-left" style="margin:5px 0 0 0; padding:0 0 0 20px; border:solid 0px red;"><li>{{$t(record.line4)}}</li></div>
                </span>
            </span>
        </span>
        <span   v-if="typeof record.line5!=='undefined' ">
            <span   v-if="record.line5.trim().length>0">
                <span   v-if="$t(record.line5).trim().length>0">
                    <div  class="clearfix text-left" style="margin:5px 0 0 0; padding:0 0 0 20px; border:solid 0px red;"><li>{{$t(record.line5)}}</li></div>
                </span>
            </span>
        </span>
        <span   v-if="typeof record.line6!=='undefined' ">
            <span   v-if="record.line6.trim().length>0">
                <span   v-if="$t(record.line6).trim().length>0">
                    <div  class="clearfix text-left" style="margin:5px 0 0 0; padding:0 0 0 20px; border:solid 0px red;"><li>{{$t(record.line6)}}</li></div>
                </span>
            </span>
        </span>
        <span   v-if="typeof record.line7!=='undefined' ">
            <span   v-if="record.line7.trim().length>0">
                <span   v-if="$t(record.line7).trim().length>0">
                    <div  class="clearfix text-left" style="margin:5px 0 0 0; padding:0 0 0 20px; border:solid 0px red;"><li>{{$t(record.line7)}}</li></div>
                </span>
            </span>
        </span>
        <span   v-if="typeof record.line8!=='undefined' ">
            <span   v-if="record.line8.trim().length>0">
                <span   v-if="$t(record.line8).trim().length>0">
                    <div  class="clearfix text-left" style="margin:5px 0 0 0; padding:0 0 0 20px; border:solid 0px red;"><li>{{$t(record.line8)}}</li></div>
                </span>
            </span>
        </span>
        <span   v-if="typeof record.line9!=='undefined' ">
            <span   v-if="record.line9.trim().length>0">
                <span   v-if="$t(record.line9).trim().length>0">
                    <div  class="clearfix text-left" style="margin:5px 0 0 0; padding:0 0 0 20px; border:solid 0px red;"><li>{{$t(record.line9)}}</li></div>
                </span>
            </span>
        </span>
        <span   v-if="typeof record.line10!=='undefined' ">
            <span   v-if="record.line10.trim().length>0">
                <span   v-if="$t(record.line10).trim().length>0">
                    <div  class="clearfix text-left" style="margin:5px 0 0 0; padding:0 0 0 20px; border:solid 0px red;"><li>{{$t(record.line10)}}</li></div>
                </span>
            </span>
        </span>
    </div>  
</template>

<script>
    export default {
        props: {
            record: {
                type: Object,
            },
            graduallyView: {
                type: String
            }
        },
    }
</script>

<style lang="scss" scoped>
    .topMargin {height:20px;}
</style>